var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_3252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.375V20.625",
    stroke: "#007BFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 4.875H8.3125C7.50027 4.875 6.72132 5.19766 6.14699 5.77199C5.57266 6.34632 5.25 7.12527 5.25 7.9375C5.25 8.74973 5.57266 9.52868 6.14699 10.103C6.72132 10.6773 7.50027 11 8.3125 11H12.6875C13.4997 11 14.2787 11.3227 14.853 11.897C15.4273 12.4713 15.75 13.2503 15.75 14.0625C15.75 14.8747 15.4273 15.6537 14.853 16.228C14.2787 16.8023 13.4997 17.125 12.6875 17.125H5.25",
    stroke: "#007BFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_3252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySign);
export default __webpack_public_path__ + "static/media/money-sign.fff67da834481b61ab152bba7bdba489.svg";
export { ForwardRef as ReactComponent };